import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        haswell: '='
    },
    template: `
    <div ng-class="{ 'well color02': vm.haswell != false}">
        <h2 ng-if="vm.haswell!=false">{{ 'questions.Advanced settings' | translate }}</h2>
        <div class="form">
        </div>
    </div>
    `
})

export default class {}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/advanced/index.js